module.exports = __webpack_public_path__ + "img/01-thumb.440608b3.jpg";